<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <div class="wrapper">
      <side-bar
        :sidebar-links="sidebarLinkItems"
        :logo="require('@/assets/img/two-beads-logo.png')"
      />
      <div class="main-panel">
        <top-navbar />
        <app-content @click.native="toggleSidebar" />
        <content-footer />
      </div>
    </div>
  </div>
</template>

<script>
import TopNavbar from '@/layouts/app/top-navbar.vue'
import ContentFooter from '@/layouts/app/app-footer.vue'
import AppContent from '@/layouts/app/app-content.vue'
import security from '@/services/security.js'
import sidebarLinks from '@/services/static/sidebar-links.js'

export default {
  components: {
    TopNavbar,
    ContentFooter,
    AppContent
  },
  data: function () {
    return {
      sidebarLinkItems: []
    }
  },
  created: function () {
    this.$root.$on('course-change', this.setupSideMenu)
    this.setupSideMenu()
  },
  methods: {
    setupSideMenu: function () {
      if (this.$root.courseScouterType === 'Staff') {
        this.sidebarLinkItems = sidebarLinks.getStaffLinkItems(
          this.$root.courseStatus
        )
      } else if (this.$root.courseScouterType === 'Participant') {
        this.sidebarLinkItems = sidebarLinks.getParticipantLinkItems()
      } else {
      }
    },
    toggleSidebar: function () {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    logout: function () {
      security.teardownVueSession(this.$root)
      this.$router.push('/login')
    },
    login: function () {
      if (this.$route.path !== '/login') {
        this.$router.push('/login')
      }
    },
    changePassword: function () {
      this.$router.push('/change-password')
    },
    createCourse: function () {
      this.$router.push('/create-course')
    },
    acceptInvitation: function () {
      this.$router.push('/login?addcourse=1')
    }
  }
}
</script>
